/* hs-eslint ignored failing-rules */

'use es6';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
import ChatAssignmentsApi from '../../api/ChatAssignmentsApi';
import PoweredByFooter from './PoweredByFooter';
import OptionsPanel from '../panel/OptionsPanel';
import TakeNextChatButton from './TakeNextChatButton';
import Track from '../../tracking/RepChatAssignmentTracker';
import UnassignedQueueSummary from './UnassignedQueueSummary';
import UserPreferences from '../../models/UserPreferences';
import UserPreferencesApi from '../../api/UserPreferencesApi';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const QUEUE_UPDATE_INTERVAL_MILLIS = 2000;
const chatAssignmentsApi = new ChatAssignmentsApi();
const userPreferencesApi = new UserPreferencesApi();
function RepChatAssignmentCardContent(props) {
  const [isOptionsPanelOpen, setOptionsPanelOpen] = useState(false);
  const [userPreferences, setUserPreferences] = useState(new UserPreferences());
  const [queueStatus, setQueueStatus] = useState({});
  const [failedAssign, setFailedAssign] = useState(false);
  const currentInboxId = useSelector(({
    unifiedInbox
  }) => unifiedInbox.currentInbox.id);
  const dispatch = useDispatch();
  const isQueueEmpty = queue => {
    return Object.values(queue).reduce((total, count) => total + count, 0) === 0;
  };
  useEffect(() => {
    userPreferencesApi.getUserPreferences().then(setUserPreferences).catch(console.log);
  }, []);
  useEffect(() => {
    chatAssignmentsApi.getUnassignedChatsCount(currentInboxId).then(setQueueStatus).catch(console.log);
    const intervalId = setInterval(() => {
      chatAssignmentsApi.getUnassignedChatsCount(currentInboxId).then(status => {
        setQueueStatus(status);
        if (!isQueueEmpty(status)) {
          setFailedAssign(false);
        }
      }).catch(console.log);
    }, QUEUE_UPDATE_INTERVAL_MILLIS);
    return () => {
      clearInterval(intervalId);
    };
  }, [currentInboxId]);
  const countMatchesPreferences = () => {
    const {
      primaryLanguage,
      secondaryLanguage
    } = userPreferences;
    return Object.keys(queueStatus).includes(primaryLanguage) && (secondaryLanguage ? Object.keys(queueStatus).includes(secondaryLanguage) : true);
  };
  const shouldDisableTakeNextChatButton = () => {
    return !userPreferences.primaryLanguage || !countMatchesPreferences() || isQueueEmpty(queueStatus);
  };
  const handleOptionsLinkClick = () => {
    Track.optionsOpened();
    setOptionsPanelOpen(true);
  };
  const handleTakeNextChatButtonClick = () => {
    chatAssignmentsApi.assignNextApplicableChat(currentInboxId).then(threadId => {
      Track.takeNextChatClicked(threadId);
      dispatch(props.navigateToThread({
        threadId
      }));
    }, () => setFailedAssign(true)).catch(console.log);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isOptionsPanelOpen ? /*#__PURE__*/_jsx(OptionsPanel, {
      "data-test-id": "queue-card-options-panel",
      onClose: () => setOptionsPanelOpen(false),
      setUserPreferences: setUserPreferences,
      userPreferences: userPreferences
    }) : null, countMatchesPreferences() ? /*#__PURE__*/_jsx(UnassignedQueueSummary, {
      "data-test-id": "queue-card-status",
      queueStatus: queueStatus,
      userPreferences: userPreferences
    }) : /*#__PURE__*/_jsx(LoadingSpinner, {
      "data-test-id": "queue-card-loading",
      layout: "centered"
    }), /*#__PURE__*/_jsx(TakeNextChatButton, {
      "data-test-id": "take-next-chat-button",
      disabled: shouldDisableTakeNextChatButton(),
      failed: failedAssign,
      onClick: handleTakeNextChatButtonClick
    }), /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      blockSize: "20px",
      children: [/*#__PURE__*/_jsx(PoweredByFooter, {
        "data-test-id": "queue-card-powered-by"
      }), /*#__PURE__*/_jsx(Link, {
        "data-test-id": "queue-card-options-link",
        onClick: handleOptionsLinkClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.card.queue.options.label"
        })
      })]
    })]
  });
}
RepChatAssignmentCardContent.propTypes = {
  navigateToThread: PropTypes.func.isRequired
};
function RepChatAssignmentCardTitle() {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "app.card.queue.title"
  });
}
export { RepChatAssignmentCardContent, RepChatAssignmentCardTitle };